import { z } from 'zod';
import { BrandSchema, HourFormat } from './brand';
import { TimeSchema } from './time';
import { objectIdSchema } from './objectId';
import { PropertyBerthingSchema } from './propertyBerthing';

export const PropertyType = ['sea', 'shore'] as const;

export const PropertyTagSchema = z.object({
  _id: objectIdSchema,
  name: z.string(),
});

export const PropertyZoneSchema = z.object({
  _id: objectIdSchema,
  name: z.string(),
  color: z.string(),
});

export const PropertySettingsSchema = z.object({
  ddpDaysBeforeLimit: z.number().optional(),
  ddpDaysAfterLimit: z.number().optional(),
  hourFormat: z.enum(HourFormat).optional(),
  prevDayOverflowHrs: z.number().optional(),
  nextDayOverflowHrs: z.number().optional(),
  naveganteMobileDayCap: z.number().optional(),
});

export const PropertySchema = z.object({
  _id: objectIdSchema,
  name: z.string(),
  active: z.boolean(),
  location: z.string(),
  description: z.string(),
  images: z.string().array(),
  brand: BrandSchema,
  type: z.enum(PropertyType),
  projectLimit: z.number().default(0),
  staffBerthings: PropertyBerthingSchema.array(),
  isLocked: z.boolean().default(false),
  tags: PropertyTagSchema.array(),
  contentTags: PropertyTagSchema.array(),
  zones: PropertyZoneSchema.array(),
  dayStart: TimeSchema.optional(),
  settings: PropertySettingsSchema.optional(),
});

export const NewPropertySchema = z.object({
  name: z.string(),
  brand: objectIdSchema,
  description: z.string(),
  location: z.string(),
  zones: PropertyZoneSchema.array(),
  type: z.enum(PropertyType),
  dayStart: TimeSchema.optional(),
});

export const BarePropertySchema = z.object({
  _id: objectIdSchema,
  name: z.string(),
  active: z.boolean(),
  location: z.string(),
  description: z.string(),
  images: z.string().array(),
  brand: objectIdSchema,
  type: z.enum(PropertyType),
  projectLimit: z.number().optional(),
  staffBerthings: PropertyBerthingSchema.array(),
  isLocked: z.boolean().optional(),
  tags: PropertyTagSchema.array(),
  zones: PropertyZoneSchema.array(),
  contentTags: PropertyTagSchema.array(),
  dayStart: TimeSchema.optional(),
  settings: PropertySettingsSchema.optional(),
});

export type Property = z.infer<typeof PropertySchema>;
export type BareProperty = z.infer<typeof BarePropertySchema>;
